import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePairAssignmentsInput_InputAdapter_instance10fqrow9fvrw0 as SavePairAssignmentsInput_InputAdapter_instance } from '../type/adapter/SavePairAssignmentsInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsMutation_VariablesAdapterClass;
function SavePairAssignmentsMutation_VariablesAdapter() {
  if (SavePairAssignmentsMutation_VariablesAdapterClass === VOID) {
    class $ {
      r6f(writer, value, customScalarAdapters, withDefaultValues) {
        writer.r47('input');
        obj(SavePairAssignmentsInput_InputAdapter_instance).p3z(writer, customScalarAdapters, value.q6f_1);
      }
    }
    initMetadataForObject($, 'SavePairAssignmentsMutation_VariablesAdapter');
    SavePairAssignmentsMutation_VariablesAdapterClass = $;
  }
  return SavePairAssignmentsMutation_VariablesAdapterClass;
}
var SavePairAssignmentsMutation_VariablesAdapter_instance;
function SavePairAssignmentsMutation_VariablesAdapter_getInstance() {
  return SavePairAssignmentsMutation_VariablesAdapter_instance;
}
//region block: init
SavePairAssignmentsMutation_VariablesAdapter_instance = new (SavePairAssignmentsMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePairAssignmentsMutation_VariablesAdapter_instance as SavePairAssignmentsMutation_VariablesAdapter_instance3rhq8e07bm4ly,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsMutation_VariablesAdapter.mjs.map
